import { observable, action } from 'mobx';
import uuid from 'uuid';
import { api } from '../config';

// Dependencies
import { notify } from 'react-notify-toast';
// var urlBase = 'http://localhost:8000';
// var myLocation = 'http://localhost:3000';

// Components
import SessionStore from './SessionStore';

var obx = observable({
  client: null,
  localMedia: {},
  room: null,
  mediaSrc: [],
  tracks: [],
  sessionObj: {},
  lookupSession: action(function(input) {
    if (input.length !== 9 && input.length !== 11) {
      notify.show(`Access code should be 11 characters`, 'error');
    } else if (input.length === 9) {
      var temp = input.split('');
      var newTemp = [];
      temp.forEach((x, index) => {
        if (index === 3 || index === 6) {
          newTemp.push('-');
          newTemp.push(x);
        } else {
          newTemp.push(x);
        }
      });
      var inputStr = newTemp.join('');
      obx.joinSession(inputStr);
    } else if (input.length === 11) {
      obx.joinSession(input);
    }
  }),
  setUpClient: action(function(token) {
    // obx.setUpLocalMedia();
    obx.joinRoom(token);
  }),
  setUpLocalMedia: action(function() {
    try {
      obx.localMedia = new window.Twilio.Video.LocalMedia();
    } catch(e) {
      console.error(e);
    }
  }),
  sendParticipantMedia: action(function(participant) {
    participant.on('trackAdded', function(track) {
      // Create an array of track data which will be used to identify elements
      // to attach the media tracks to
      const trackData = {
        kind: track.kind,
        id: track.id
      }

      obx.tracks.push(trackData);

      // Wait until the elements exist and then attach the media tracks
      setTimeout(function(){
        const trackContainer = document.querySelector(`#track-${track.id}`);
        trackContainer.appendChild(track.attach());
      });
    });
  }),
  registerTrackEvents: action(function(room) {
    room.on('participantConnected', function(participant) {
      notify.show(`${participant.identity} connected`, 'success');
    });
    room.on('participantDisconnected', function(participant) {
      notify.show(`${participant.identity} disconnected`, 'error');
      participant.media.tracks.forEach(track => obx.removeTrack(track.id));
    });
  }),
  removeTrack: action(function(id) {
    obx.mediaSrc = obx.mediaSrc.filter(x => x.id !== id);
  }),
  joinRoom: action(function(token) {
    // Create a dummy audio track to prevent the browser from asking for permission
    // const audioContext = typeof AudioContext !== 'undefined'
    //   ? new window.AudioContext()
    //   : new window.webkitAudioContext()
    // const node = audioContext.createMediaStreamDestination()
    // const stream = node.stream
    // const dummyTrack = stream.getAudioTracks()[0]
    // const audioTrack = new window.Twilio.Video.LocalAudioTrack(dummyTrack);
    //
    // console.log(audioTrack);

    window.Twilio.Video.connect(token, {
      name: obx.sessionObj.session.sessionId,
      tracks: []
    })
      .then(function onJoin(room) {
        room.participants.forEach(function(participant) {
          obx.sendParticipantMedia(participant);
        });

        room.on('participantConnected', function(participant) {
          obx.sendParticipantMedia(participant);
        });

        // obx.registerTrackEvents(room);
      })
      .catch(error => {
        console.error(error);
      });
  }),
  joinSession: action(function(id) {
    const url = `https://newapi.smarterservices.com/smarterproctoring-api/v1/sessions/${id}/join`;
    // const data = JSON.stringify({ user_id: uuid.v1() })
    // const headers = { 'Content-Type': 'application/json' };

    // axios.post(url, data, headers)

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: uuid.v1() })
    })
      .then(response => {
        return response.json();
      })
      .then(body => {
        obx.setSessionObj(body);
        obx.setUpClient(body.configuration.twilio.token);
        if(body.err) {
          notify.show('Error connecting to session', 'error');
        } else {
          notify.show('Connected to session', 'success');
        }
      })
      .catch(e => {
      });
  }),
  setSessionObj: action(function(obj) {
    obx.sessionObj = obj;
  }),
  bvData: {},
  metadata: null,
  getBVData: action(function(examSid, sessionSid) {
    SessionStore.startLoading('Loading…', 'BVData');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/meta`)
      .then(response => {
        obx.bvData = response.data;

        obx.metadata = response.data.metadata;

        SessionStore.finishLoading('BVData');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get exam review URL
  getReviewUrl: action(function(examSid, sessionSid) {
    SessionStore.startBackgroundLoading('getReviewUrl');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/review`)
      .then(response => {
        obx.reviewUrl = response.data.redirectUrl;

        if(obx.reviewUrl && obx.reviewUrl.indexOf('http:') >= 0) {
          obx.reviewUrl = obx.reviewUrl.replace('http:', 'https:');
        }

        SessionStore.finishBackgroundLoading('getReviewUrl');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get ProctorU exam review payload
  formData: null,
  getReviewPayload: action(function(examSid, sessionSid) {
    SessionStore.startBackgroundLoading('getReviewPayload');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/review`)
      .then(response => {
        if(response.data.type === 'form') {
          obx.formData = response.data.formData;
        } else {
          obx.reviewUrl = response.data.redirectUrl;

          if(obx.reviewUrl && obx.reviewUrl.indexOf('http:') >= 0) {
            obx.reviewUrl = obx.reviewUrl.replace('http:', 'https:');
          }
        }

        SessionStore.finishBackgroundLoading('getReviewPayload');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  })
});
export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/StepInStore.js